import { render, staticRenderFns } from "./Interactions.vue?vue&type=template&id=72d24ae8&scoped=true&"
import script from "./Interactions.vue?vue&type=script&lang=js&"
export * from "./Interactions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d24ae8",
  null
  
)

export default component.exports